import {
  DrawerKey,
  DrawerSlice,
  DrawersMap,
  DRAWER_FAQ_KEY,
  DRAWER_DESIGNATION_KEY,
  DRAWER_DEDICATION_KEY,
  DRAWER_COMMENT_KEY,
  DRAWER_DOUBLE_THE_DONATION_KEY,
  DRAWER_ORDER_DETAILS_KEY,
} from './drawer-types'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const drawersMap: DrawersMap = {
  [DRAWER_FAQ_KEY]: {
    key: DRAWER_FAQ_KEY,
    label: 'Frequently asked questions',
  },
  [DRAWER_DESIGNATION_KEY]: {
    key: DRAWER_DESIGNATION_KEY,
    label: "I'd like to support",
  },
  [DRAWER_DEDICATION_KEY]: {
    key: DRAWER_DEDICATION_KEY,
    label: 'Dedicate a donation',
  },
  [DRAWER_COMMENT_KEY]: {
    key: DRAWER_COMMENT_KEY,
    label: 'Leave a comment',
  },
  [DRAWER_DOUBLE_THE_DONATION_KEY]: {
    key: DRAWER_DOUBLE_THE_DONATION_KEY,
    label: 'Employer Matching',
  },
  [DRAWER_ORDER_DETAILS_KEY]: {
    key: DRAWER_ORDER_DETAILS_KEY,
    label: '',
  },
}

const drawerSlice = createSlice({
  name: 'drawer',
  initialState: null as DrawerSlice,
  reducers: {
    open: (_, action: PayloadAction<DrawerKey>) => {
      return drawersMap[action.payload]
    },
    close: () => {
      return null
    },
  },
})

export default drawerSlice
